module.exports = __webpack_public_path__ + "static/media/Tic-Tac-Code.41c28c06.jpg";